import {
  SET_EMAIL_ERROR,
  SET_PROVIDER,
  SET_DISPLAY_NAME,
  SET_PROFILE_PIC_URL,
  SET_PROVIDERS,
  SET_USER_EMAIL
} from './constant'
import { MutationTree } from 'vuex'
import { RegisterState } from './types'

export const mutations: MutationTree<RegisterState> = {
  [SET_EMAIL_ERROR](state, emailError: boolean) {
    state.emailError = emailError
  },
  [SET_PROVIDER](state, provider: string) {
    state.provider = provider
  },
  [SET_PROVIDERS](state, providers: Array<any>) {
    state.providers = providers
  },
  [SET_DISPLAY_NAME](state, displayName: string) {
    state.displayName = displayName
  },
  [SET_PROFILE_PIC_URL](state, profilePicURL: string) {
    state.profilePicURL = profilePicURL
  },
  [SET_USER_EMAIL](state, email: string) {
    state.email = email
  }
}
